import { __exports as VpTokenizedFragment } from './_virtual-VpTokenizedFragment.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import React from 'react';
import { __require as requireHtmlReactParser } from './node_modules-html-react-parser-index.js';
import { __require as requireLodash_isequal } from './node_modules-lodash.isequal-index.js';
import { __require as requireContainer } from './vp-tokenized-fragment-build-infrastructure-Container.js';

var hasRequiredVpTokenizedFragment;

function requireVpTokenizedFragment () {
	if (hasRequiredVpTokenizedFragment) return VpTokenizedFragment;
	hasRequiredVpTokenizedFragment = 1;

	var _interopRequireDefault = requireInteropRequireDefault();
	Object.defineProperty(VpTokenizedFragment, "__esModule", {
	  value: true
	});
	VpTokenizedFragment.default = void 0;
	var React$1 = _interopRequireWildcard(React);
	var _htmlReactParser = _interopRequireDefault(requireHtmlReactParser());
	var _lodash = _interopRequireDefault(requireLodash_isequal());
	var _Container = requireContainer();
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	let VpTokenizedFragment$1 = class VpTokenizedFragment extends React$1.Component {
	  constructor(props) {
	    super(props);
	    this.tokenEngine = void 0;
	    this._isMounted = false;
	    this.state = {
	      content: ''
	    };
	  }
	  componentDidMount() {
	    this._isMounted = true;
	    this.refreshContent();
	  }
	  componentDidUpdate(prevProps) {
	    if (!(0, _lodash.default)(prevProps, this.props)) {
	      const localeChanged = prevProps.culture !== this.props.culture;
	      this.refreshContent(localeChanged);
	    }
	  }
	  async componentWillUnmount() {
	    this._isMounted = false;
	  }
	  render() {
	    let renderedContent;
	    if (this.state.content !== '') {
	      renderedContent = this.state.content;
	    } else {
	      renderedContent = this.props.placeHolderText;
	    }
	    if (typeof renderedContent === 'string' && _Container.htmlIdentifier.identifyHTML(renderedContent)) {
	      return /*#__PURE__*/React$1.createElement("span", null, (0, _htmlReactParser.default)(renderedContent, this.props.replaceOptions));
	    }
	    return renderedContent;
	  }
	  refreshContent(localeChanged) {
	    if (!this._isMounted) {
	      return;
	    }
	    if (!this.props.culture) {
	      console.error('ERROR culture not specified for VpTokenizedFragment');
	      return;
	    }
	    if (localeChanged || !this.tokenEngine) {
	      this.tokenEngine = _Container.tokenEngineFactory.create(this.props.culture, this.props.tenant);
	    }
	    this.tokenEngine.render(this.props.tokenText, {
	      isTile: this.props.isTile
	    }).then(rendered => {
	      if (this._isMounted) {
	        this.setState({
	          content: rendered
	        });
	      }
	    }).catch(error => {
	      console.error('ERROR rendering token in VPTokenizedFragment', error.message);
	      if (this._isMounted) {
	        this.setState({
	          content: ''
	        });
	      }
	    });
	  }
	};
	VpTokenizedFragment.default = VpTokenizedFragment$1;
	
	return VpTokenizedFragment;
}

export { requireVpTokenizedFragment as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-VpTokenizedFragment.js.map
